/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ScopeType {
    MY_WORKSTREAMS = 'my_workstreams',
    TEAM = 'team',
    COMPANY = 'company',
    PILLAR = 'pillar',
    PERSON = 'person',
    DIRECT_REPORTS = 'direct_reports',
}
